import React from 'react'
import { ThemeProvider } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'
import { QueryClientProvider, QueryClient } from 'react-query'
import ReactDOM from 'react-dom'
import App from './App'
import reportWebVitals from './reportWebVitals'
import theme from './theme'
import LanguageProvider from './core/components/LanguageProvider'
import RedirectToProduct from 'src/pages/Orders/Components/RedirectToProduct/RedirectToProduct'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    },
  },
})

ReactDOM.render(
  <React.StrictMode>
    <LanguageProvider>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <RedirectToProduct>
            <CssBaseline />
            <App />
          </RedirectToProduct>
        </ThemeProvider>
      </QueryClientProvider>
    </LanguageProvider>
  </React.StrictMode>,
  document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
